import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface ProjetListPayload {
    page: number;
    libelle: string;
    unpaged?: boolean;
}

export class ProjetSearchDTO implements ProjetListPayload {
    page: number;
    libelle: string;
    unpaged?: boolean;

    constructor(page: number, recherche: string, unpaged?: boolean){
        this.page = page;
        this.libelle = recherche;
        this.unpaged = unpaged;
    }

}

class ProjetService {

    public async getProjets(payload: ProjetListPayload): Promise<any> {
        return http.get(Routes.ProjetRoutes.GetProjets(), {params: payload});
    }

}

export default new ProjetService();
